export default __webpack_public_path__ + "static/media/book_4.f9073434.svg";